import { ClusterIconInfo } from "@google/markerclustererplus";
import { Observable, of } from "rxjs";
import { catchError, debounceTime, switchMap } from "rxjs/operators";

export function madCalculator(
    markers: google.maps.Marker[],
    numStyles: number
): ClusterIconInfo {
    let index = 0;
    const count: number = markers.length;
    const num = markers.reduce((val, marker) => {
        // One marker stands for every comparable sharing its coordinate, joined into a
        // single '/'-separated label, so the cluster counts comparables and not pins.
        const label = marker.getLabel();
        return val + (label && label.text ? label.text.split('/').length : 1);
    }, 0)

    let dv = count;
    while (dv !== 0) {
        dv = Math.floor(dv / 10);
        index++;
    }

    index = Math.min(index, numStyles);
    return {
        text: num.toString(),
        index: index,
        title: ''
    }
}

/**
 * The markers come from their own request, separate from the paginated one that feeds the
 * table below them: the table shows one page, the map has to show everything inside the
 * viewport. Both are driven by the same filter, viewport bounds included.
 *
 * Bounds change on every drag and zoom, hence the debounce, and `switchMap` drops the
 * response of a viewport the user has already moved away from.
 */
export function fetchMapMarkers<T>(
    filter$: Observable<any>,
    load: (filter: any) => Observable<T[]>
): Observable<T[]> {
    return filter$.pipe(
        debounceTime(300),
        switchMap(filter => load(filter).pipe(
            // One failed viewport must not tear down the stream and leave the map dead
            // for the rest of the session.
            catchError(() => of([] as T[]))
        ))
    );
}

